import React, { useState, useRef, useEffect } from "react";
import Transition from "../utils/Transition.js";

function Tabs() {
  const [tab, setTab] = useState('elude');

  const tabs = useRef(null);

  const heightFix = () => {
    if (tabs.current.children[tab]) {
      tabs.current.style.height =
        tabs.current.children[tab - 1].offsetHeight + "px";
    }
  };

  useEffect(() => {
    return () => {
      heightFix();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-12 md:py-20 border-t border-gray-800">
          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12" data-aos-id-tabs>
            <h2
              className="h2 mb-4"
              data-aos="fade-up"
              data-aos-anchor="[data-aos-id-tabs]"
            >
              We invest in companies that strive to maximize human agency with
              technology.
            </h2>
            {/* <p
              className="text-xl text-gray-400"
              data-aos="fade-up"
              data-aos-delay="200"
              data-aos-anchor="[data-aos-id-tabs]"
            >
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt mollit laborum — semper quis lectus nulla.
            </p> */}
          </div>

          {/* Section content */}
          <div>
            {/* Tabs buttons */}
            <div
              className="flex flex-wrap justify-center -m-2"
              data-aos="fade-up"
              data-aos-delay="400"
              data-aos-anchor="[data-aos-id-tabs]"
            >
              <button
                className={`flex items-center font-medium py-2 px-4 m-2 bg-gray-800 rounded-full group transition duration-500 ${
                  tab !== 'elude' && "opacity-50"
                }`}
                onClick={() => setTab('elude')}
              >
                <svg
                  className="w-4 h-4 fill-current text-purple-600 mr-2"
                  viewBox="0 0 502 502"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M251,64.679c-51.217,0-97.836,20.04-132.447,52.682c-0.487,0.352-0.953,0.746-1.383,1.195 c-0.235,0.246-0.455,0.502-0.661,0.765c-36.183,35.132-58.706,84.258-58.706,138.554c0,106.529,86.667,193.196,193.196,193.196 c106.528,0,193.196-86.667,193.196-193.196S357.528,64.679,251,64.679z M250.999,84.677c13.543,0,28.264,17.637,39.378,47.178 c11.721,31.154,18.542,72.037,19.442,116.018h-99.631c-5.523,0-10,4.477-10,10s4.478,10.002,10.001,10.002h99.631 c-0.502,24.557-2.85,48.146-6.868,69.616c-16.748-4.663-34.2-7.087-51.952-7.087c-17.758,0-35.208,2.423-51.953,7.083 c-4.56-24.37-6.973-51.468-6.973-79.613c0-27.809,2.358-54.594,6.812-78.737c16.781,4.682,34.281,7.115,52.113,7.115 c8.926,0,17.905-0.616,26.687-1.83c5.471-0.756,9.293-5.804,8.537-11.275c-0.757-5.472-5.812-9.298-11.275-8.537 c-7.878,1.089-15.936,1.641-23.949,1.641c-16.402,0-32.491-2.294-47.892-6.708c2.456-9.868,5.3-19.145,8.514-27.688 C222.735,102.313,237.456,84.677,250.999,84.677z M211.282,89.281c-6.818,9.357-13.009,21.26-18.379,35.534 c-3.278,8.712-6.194,18.117-8.733,28.08c-16.098-6.732-31.177-15.923-44.744-27.375 C159.884,108.247,184.38,95.617,211.282,89.281z M78.099,267.875h25.074c5.523,0,10-4.477,10-10s-4.477-10-10-10H78.099 c2.395-41.86,19.722-79.782,46.727-108.515c16.492,14.248,35.049,25.461,54.935,33.344c-5.024,26.116-7.686,55.129-7.686,85.17 c0,30.369,2.722,59.685,7.853,86.021c-19.76,7.814-38.217,18.915-54.631,32.999C98.021,348.103,80.509,309.98,78.099,267.875z M139.964,390.687c13.483-11.282,28.454-20.35,44.42-27.002c2.49,9.654,5.332,18.781,8.519,27.251 c5.37,14.273,11.561,26.177,18.379,35.534C184.616,420.189,160.313,407.727,139.964,390.687z M251,431.072 c-13.542,0-28.264-17.637-39.378-47.178c-3.121-8.296-5.894-17.283-8.301-26.833c15.347-4.382,31.369-6.656,47.679-6.656 c16.305,0,32.329,2.274,47.679,6.658c-2.407,9.549-5.18,18.535-8.301,26.831C279.264,413.436,264.543,431.072,251,431.072z M290.718,426.47c6.818-9.357,13.009-21.26,18.38-35.533c3.186-8.47,6.028-17.597,8.517-27.251 c15.967,6.652,30.94,15.72,44.422,26.999C341.688,407.726,317.384,420.189,290.718,426.47z M376.7,376.899 c-16.411-14.08-34.869-25.18-54.629-32.994c4.567-23.436,7.224-49.231,7.754-76.029h94.076 C421.491,309.981,403.978,348.106,376.7,376.899z M329.825,247.875c-0.917-46.367-8.193-89.747-20.727-123.061 c-5.37-14.273-11.562-26.177-18.38-35.533c26.609,6.267,50.866,18.689,71.188,35.674c-8.326,7.092-17.302,13.396-26.797,18.792 c-4.801,2.729-6.481,8.833-3.753,13.635c1.843,3.242,5.224,5.061,8.703,5.061c1.675,0,3.372-0.421,4.933-1.308 c11.238-6.386,21.816-13.922,31.573-22.429c27.356,28.81,44.923,66.993,47.336,109.169H329.825z"/> <path d="M153.96,247.875h-20.859c-5.523,0-10,4.477-10,10s4.477,10,10,10h20.859c5.523,0,10-4.477,10-10 S159.483,247.875,153.96,247.875z"/> <path d="M483.157,193.007c5.248-1.722,8.106-7.372,6.385-12.619c-16.351-49.838-47.427-92.699-89.87-123.949 C356.356,24.548,304.946,7.691,251,7.691c-67.044,0-130.076,26.108-177.484,73.516C26.108,128.615,0,191.647,0,258.691 c0,34.453,6.856,67.836,20.378,99.225c12.019,27.898,28.792,53.066,49.893,74.935c-3.592,6.07-5.662,13.142-5.662,20.692 c0,22.479,18.288,40.766,40.766,40.766c22.478,0,40.766-18.288,40.766-40.766c0-22.478-18.288-40.766-40.766-40.766 c-7.689,0-14.886,2.142-21.03,5.857C42.798,375.421,20,318.934,20,258.691c0-127.374,103.626-231,231-231 c100.126,0,188.352,63.87,219.538,158.931C472.26,191.871,477.911,194.729,483.157,193.007z M105.375,432.776 c11.451,0,20.766,9.316,20.766,20.766c0,11.451-9.315,20.766-20.766,20.766s-20.766-9.315-20.766-20.766 S93.924,432.776,105.375,432.776z"/> <path d="M499.344,222.052c-0.8-5.465-5.883-9.249-11.342-8.447c-5.465,0.799-9.247,5.877-8.447,11.342 c1.622,11.091,2.445,22.444,2.445,33.744c0,5.523,4.478,10,10,10c5.522,0,10-4.477,10-10 C502,246.426,501.106,234.099,499.344,222.052z"/>
                </svg>
                <span className="text-gray-400 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  Elude
                </span>
              </button>
              <button
                className={`flex items-center font-medium py-2 px-4 m-2 bg-gray-800 rounded-full group transition duration-500 ${
                  tab !== 'reframe' && "opacity-50"
                }`}
                onClick={() => setTab('reframe')}
              >
                <svg
                  className="w-4 h-4 fill-current text-purple-600 mr-2"
                  viewBox="0 0 501.334 501.334"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g> <g> <path d="M389.867,30.933c-18.133-18.133-40.533-28.8-65.067-28.8c-28.8,0-55.467,13.867-73.6,38.4C232,16,206.4,0,176.534,0 c-53.333,0-96,50.133-99.2,117.333c-3.2,80,140.8,212.267,156.8,227.2c4.267,3.2,8.533,5.333,13.867,5.333 c4.267,0,9.6-1.067,12.8-4.267c17.067-12.8,160-128,163.2-222.933C424,87.467,412.267,54.4,389.867,30.933z M382.4,121.6 c-2.133,57.6-86.4,140.8-132.267,180.267c-56.533-53.333-132.267-140.8-130.133-182.4c2.133-43.733,26.667-77.867,57.6-77.867 c23.467,0,44.8,21.333,53.333,52.267c3.2,8.533,10.667,14.933,20.267,14.933c9.6,0,18.133-6.4,20.267-14.933 C280,64,302.4,43.733,325.867,43.733c14.933,0,26.667,8.533,34.133,16C374.934,74.666,383.467,97.066,382.4,121.6z"/> </g> </g> <g> <g> <path d="M225.6,472.534l-27.733-65.067c-12.8-29.867-40.533-51.2-72.533-57.6l-12.8-2.133c-16-3.2-29.867-13.867-38.4-27.733 L40,261.333c-6.4-9.6-19.2-12.8-28.8-7.467c-9.6,6.4-12.8,19.2-7.467,28.8l34.133,58.667c14.933,24.533,39.467,41.6,67.2,46.933 l12.8,2.133c18.133,3.2,34.133,16,41.6,33.067l27.733,65.067c3.2,8.533,10.667,12.8,19.2,12.8c2.133,0,5.333-1.067,8.533-1.067 C225.6,494.934,229.867,483.2,225.6,472.534z"/> </g> </g> <g> <g> <path d="M490.134,252.8c-10.667-5.333-23.467-2.133-28.8,7.467L427.2,318.934c-8.533,14.933-22.4,24.533-38.4,27.733 l-13.867,2.133c-32,5.333-59.733,27.733-72.533,57.6l-27.733,65.067c-4.267,10.667,0,23.467,10.667,27.733 c3.2,1.067,5.333,2.133,8.533,2.133c8.533,0,16-4.267,20.267-13.867l27.733-65.067c7.467-17.067,23.467-29.867,41.6-33.067 l12.8-2.133c27.733-4.267,52.267-22.4,67.2-46.933l34.133-58.667C502.934,270.933,499.734,258.133,490.134,252.8z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g>
                </svg>
                <span className="text-gray-400 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  Reframe
                </span>
              </button>
              <button
                className={`flex items-center font-medium py-2 px-4 m-2 bg-gray-800 rounded-full group transition duration-500 ${
                  tab !== 'electric-sms' && "opacity-50"
                }`}
                onClick={() => setTab('electric-sms')}
              >
                <svg
                  class="header-logo"
                  width="10"
                  viewBox="0 0 50 74"
                  version="1.1"
                >
                  <g
                    id="Logo"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g
                      id="AppIcon"
                      transform="translate(-127.000000, -113.000000)"
                      fill="#00E364"
                    >
                      <g
                        id="Group-2"
                        transform="translate(125.000000, 106.000000)"
                      >
                        <g id="Group">
                          <path
                            d="M2.79212515,45.8347353 L25.265456,9.08971201 C26.1299278,7.67625721 27.9765522,7.23121858 29.390007,8.0956904 C30.2812505,8.64077677 30.8247423,9.61025941 30.8247423,10.6549767 L30.8247423,37.8666667 L30.8247423,37.8666667 L46.6092597,37.8666667 C48.2661139,37.8666667 49.6092597,39.2098124 49.6092597,40.8666667 C49.6092597,41.4254001 49.4532254,41.9730312 49.1587373,42.4478573 L26.4566941,79.052142 C25.5834267,80.4601796 23.7340635,80.8936965 22.3260259,80.020429 C21.4438556,79.4733054 20.9072165,78.5090113 20.9072165,77.4709514 L20.9072165,50.4 L20.9072165,50.4 L5.35141146,50.4 C3.69455721,50.4 2.35141146,49.0568542 2.35141146,47.4 C2.35141146,46.8476216 2.503919,46.3059668 2.79212515,45.8347353 Z"
                            id="Path"
                          ></path>
                          <ellipse
                            id="Oval"
                            cx="44.5205479"
                            cy="22.7096774"
                            rx="7.47945205"
                            ry="7.4516129"
                          ></ellipse>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
                <span
                  className="text-gray-400 group-hover:text-gray-200 transition-colors duration-150 ease-in-out"
                  style={{ paddingLeft: 10 }}
                >
                  ElectricSMS
                </span>
              </button>
              <button
                className={`flex items-center font-medium py-2 px-4 m-2 bg-gray-800 rounded-full group transition duration-500 ${
                  tab !== 'zenaholic' && "opacity-50"
                }`}
                onClick={() => setTab('zenaholic')}
              >
                <svg
                  className="w-4 h-4 fill-current text-purple-600 mr-2"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M9.043 6.293S9.79 1.905 6.745 0A5.37 5.37 0 014.72 3.887C3.42 5.03.974 7.6 1 10.34A6.285 6.285 0 004.451 16a3.984 3.984 0 011.394-2.755 3.253 3.253 0 001.246-2.185 5.856 5.856 0 013.1 4.881v.013a5.883 5.883 0 003.428-5.106c.216-2.574-1.194-6.074-2.445-7.218a6.793 6.793 0 01-2.13 2.663z" />
                </svg>
                <span className="text-gray-400 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  Zenaholic
                </span>
              </button>
              <button
                className={`flex items-center font-medium py-2 px-4 m-2 bg-gray-800 rounded-full group transition duration-500 ${
                  tab !== 'smart-suite' && "opacity-50"
                }`}
                onClick={() => setTab('smart-suite')}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#3cc0de"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-book"
                >
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                </svg>
                <span
                  className="text-gray-400 group-hover:text-gray-200 transition-colors duration-150 ease-in-out"
                  style={{ paddingLeft: 5 }}
                >
                  SmartSuite
                </span>
              </button>
              <button
                className={`flex items-center font-medium py-2 px-4 m-2 bg-gray-800 rounded-full group transition duration-500 ${
                  tab !== 'filecoin' && "opacity-50"
                }`}
                onClick={() => setTab('filecoin')}
              >
                <svg
                  className="w-4 h-4 fill-current text-purple-600 mr-2"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 10c-1.1 0-2-.9-2-2 0-.2 0-.3.1-.5L3.6 5 5 3.6l2.5 2.5c.2-.1.3-.1.5-.1 1.1 0 2 .9 2 2s-.9 2-2 2z" />
                </svg>
                <span className="text-gray-400 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  Filecoin
                </span>
              </button>
              <button
                className={`flex items-center font-medium py-2 px-4 m-2 bg-gray-800 rounded-full group transition duration-500 ${
                  tab !== 'our-news' && "opacity-50"
                }`}
                onClick={() => setTab('our-news')}
              >
                <svg
                  className="w-4 h-4 fill-current text-purple-600 mr-2"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M8 9v6a8 8 0 008-8V1a8 8 0 00-8 8zM0 6v3a6 6 0 006 6v-3a6 6 0 00-6-6z" />
                </svg>
                <span className="text-gray-400 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  Our.News
                </span>
              </button>
              <button
                className={`flex items-center font-medium py-2 px-4 m-2 bg-gray-800 rounded-full group transition duration-500 ${
                  tab !== 'vessel' && "opacity-50"
                }`}
                onClick={() => setTab('vessel')}
              >
                <svg
                  className="w-4 h-4 fill-current text-purple-600 mr-2"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M14.936 6.007H8.358l1.594-4.685c.3-.997-.897-1.794-1.694-.997L.284 8.3c-.598.598-.199 1.694.698 1.694H7.56l-1.594 4.685c-.3.997.897 1.794 1.694.997L15.633 7.7c.598-.598.2-1.694-.697-1.694z" />
                </svg>
                <span className="text-gray-400 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  Vessel
                </span>
              </button>
              <button
                className={`flex items-center font-medium py-2 px-4 m-2 bg-gray-800 rounded-full group transition duration-500 ${
                  tab !== 'space-game' && "opacity-50"
                }`}
                onClick={() => setTab('space-game')}
              >
                <svg
                  class="w-4 h-4 mr-2" 
                  fill="#3cc0de"
                  xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 640 512"
                >
                  <path d="M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z" />
                </svg>
                <span className="text-gray-400 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  space.game
                </span>
              </button>
              <button
                className={`flex items-center font-medium py-2 px-4 m-2 bg-gray-800 rounded-full group transition duration-500 ${
                  tab !== 'betterment' && "opacity-50"
                }`}
                onClick={() => setTab('betterment')}
              >
                  <svg
                    class="w-4 h-4 mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    fill="#00E364"
                  >
                    <path d="M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z" />
                  </svg>
                <span className="text-gray-400 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  Betterment
                </span>
              </button>
              <button
                className={`flex items-center font-medium py-2 px-4 m-2 bg-gray-800 rounded-full group transition duration-500 ${
                  tab !== 'loft-orbital' && "opacity-50"
                }`}
                onClick={() => setTab('loft-orbital')}
              >
                  <svg className="w-4 h-4 mr-2 text-purple-600" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"></path></svg>
                <span className="text-gray-400 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  Loft Orbital
                </span>
              </button>
            </div>

            {/* Tabs items */}
            <div
              className="relative flex flex-col mt-16"
              data-aos="fade-up"
              ref={tabs}
            >

              {/* ElectricSMS */}
              <Transition
                show={tab === 'electric-sms'}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-md mx-auto md:max-w-none">
                  <figure className="md:absolute md:inset-y-0 md:right-0 md:w-1/2">
                    <img
                      className="w-full h-full object-contain"
                      src={require("../images/esmsphone.png")}
                      width="516"
                      height="387"
                      alt="ElectricSMS"
                    />
                  </figure>
                  <div className="relative bg-gray-800 py-8 md:py-16 px-6 md:pr-16 md:max-w-lg lg:max-w-xl">
                    <h4 className="h4 mb-2">ElectricSMS</h4>
                    <p className="text-lg text-gray-400">
                      ElectricSMS allows users to manage their subscribtions via
                      text. By allowing users to easily modify, skip, add-on,
                      and even cancel, businesses that use ElectricSMS have
                      seeen drastically reduced user churn and customer service
                      costs.
                    </p>
                    <a
                      className="btn-sm text-white bg-purple-600 hover:bg-purple-700 mt-6"
                      href="https://electricsms.com/"
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </a>
                  </div>
                </article>
              </Transition>

              {/* Zenaholic */}
              <Transition
                show={tab === 'zenaholic'}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-md mx-auto md:max-w-none">
                  <figure className="md:absolute md:inset-y-0 md:left-0 md:w-1/2">
                    <img
                      className="w-full h-full object-cover"
                      src={require("../images/zenaholic.jpg")}
                      width="516"
                      height="387"
                      alt="Zenaholic"
                    />
                  </figure>
                  <div className="relative bg-gray-800 py-8 md:py-16 px-6 md:pl-16 md:max-w-lg lg:max-w-xl md:ml-auto">
                    <h4 className="h4 mb-2">Zenaholic</h4>
                    <p className="text-lg text-gray-400">
                      Zenaholic is an app that uses ML and cognitive behavior
                      therapy techniques to help users with their mental health.
                      Launching soon!
                    </p>
                    <a
                      className="btn-sm text-white bg-purple-600 hover:bg-purple-700 mt-6"
                      href="https://zenaholic.com/"
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </a>
                  </div>
                </article>
              </Transition>

              {/* SmartSuite */}
              <Transition
                show={tab === 'smart-suite'}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-md mx-auto md:max-w-none">
                  <figure className="md:absolute md:inset-y-0 md:left-0 md:w-1/2">
                    <img
                      className="w-full h-full object-cover"
                      src={require("../images/news-02.jpg")}
                      width="516"
                      height="387"
                      alt="SmartSuite"
                    />
                  </figure>
                  <div className="relative bg-gray-800 py-8 md:py-16 px-6 md:pl-16 md:max-w-lg lg:max-w-xl md:ml-auto">
                    <h4 className="h4 mb-2">SmartSuite</h4>
                    <p className="text-lg text-gray-400">
                      A serious no-code solution to be launching soon!
                    </p>
                    {/* <a
                      className="btn-sm text-white bg-purple-600 hover:bg-purple-700 mt-6"
                      href="#0"
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </a> */}
                  </div>
                </article>
              </Transition>

              {/* Filecoin */}
              <Transition
                show={tab === 'filecoin'}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-md mx-auto md:max-w-none">
                  <figure className="md:absolute md:inset-y-0 md:right-0 md:w-1/2">
                    <img
                      className="w-full h-full object-cover"
                      src={require("../images/storage.jpg")}
                      width="516"
                      height="387"
                      alt="Filecoin"
                    />
                  </figure>
                  <div className="relative bg-gray-800 py-8 md:py-16 px-6 md:pr-16 md:max-w-lg lg:max-w-xl">
                    <h4 className="h4 mb-2">Filecoin</h4>
                    <p className="text-lg text-gray-400">
                      Filecoin is a decentralized storage network that has the
                      potential to make storage cheap, accessible, censor
                      resistant and resilient. It might change the fabric of the
                      internet.
                    </p>
                    <a
                      className="btn-sm text-white bg-purple-600 hover:bg-purple-700 mt-6"
                      href="https://filecoin.io"
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </a>
                  </div>
                </article>
              </Transition>

              {/* Our.News */}
              <Transition
                show={tab === 'our-news'}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-md mx-auto md:max-w-none">
                  <figure className="md:absolute md:inset-y-0 md:left-0 md:w-1/2">
                    <img
                      className="w-full h-full object-cover"
                      src={require("../images/ournews.jpg")}
                      width="516"
                      height="387"
                      alt="Our.News"
                    />
                  </figure>
                  <div className="relative bg-gray-800 py-8 md:py-16 px-6 md:pl-16 md:max-w-lg lg:max-w-xl md:ml-auto">
                    <h4 className="h4 mb-2">Our.News</h4>
                    <p className="text-lg text-gray-400">
                      Our.News is fighting back against misinformation by
                      allowing users to rate, fact check and get information
                      about sources for all online news.
                    </p>
                    <a
                      className="btn-sm text-white bg-purple-600 hover:bg-purple-700 mt-6"
                      href="https://our.news"
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </a>
                  </div>
                </article>
              </Transition>

              {/* Vessel */}
              <Transition
                show={tab === 'vessel'}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-md mx-auto md:max-w-none">
                  <figure className="md:absolute md:inset-y-0 md:right-0 md:w-1/2">
                    <img
                      className="w-full h-full object-cover"
                      src={require("../images/news-08.jpg")}
                      width="516"
                      height="387"
                      alt="Vessel"
                    />
                  </figure>
                  <div className="relative bg-gray-800 py-8 md:py-16 px-6 md:pr-16 md:max-w-lg lg:max-w-xl">
                    <h4 className="h4 mb-2">Vessel</h4>
                    <p className="text-lg text-gray-400">
                      Pee on a card and see what's wrong with you, made possible
                      by fancy development and computer vision.
                    </p>
                    <a
                      className="btn-sm text-white bg-purple-600 hover:bg-purple-700 mt-6"
                      href="https://vesselhealth.com"
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </a>
                  </div>
                </article>
              </Transition>


              {/* Reframe */}
              <Transition
                show={tab === 'reframe'}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-md mx-auto md:max-w-none">
                  <figure className="md:absolute md:inset-y-0 md:right-0 md:w-1/2">
                    <img
                      className="w-full h-full object-cover"
                      src={require("../images/reframe.png")}
                      width="516"
                      height="387"
                      alt="Reframe"
                    />
                  </figure>
                  <div className="relative bg-gray-800 py-8 md:py-16 px-6 md:pr-16 md:max-w-lg lg:max-w-xl">
                    <h4 className="h4 mb-2">Reframe</h4>
                    <p className="text-lg text-gray-400">
                    Reframe is creating the next wave of elder care insurance to enable those in their later years a graceful end and provide peace of mind to their families and children that mom or dad leaving won’t break the bank.
                    </p>
                    <a
                      className="btn-sm text-white bg-purple-600 hover:bg-purple-700 mt-6"
                      href="https://www.helloreframe.com/"
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </a>
                  </div>
                </article>
              </Transition>

              {/* Elude */}
              <Transition
                show={tab === 'elude'}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-md mx-auto md:max-w-none">
                  <figure className="md:absolute md:inset-y-0 md:right-0 md:w-1/2">
                    <img
                      className="w-full h-full object-contain"
                      src={require("../images/elude.png")}
                      width="516"
                      height="387"
                      alt="Elude"
                    />
                  </figure>
                  <div className="relative bg-gray-800 py-8 md:py-16 px-6 md:pr-16 md:max-w-lg lg:max-w-xl">
                    <h4 className="h4 mb-2">Elude</h4>
                    <p className="text-lg text-gray-400">
                    Elude the ordinary. Elude allows you to name a price and see flight plus hotel itineraries for cites around the world, based on where you live and how much you can afford. Paris, Bali, Buenos Aires, Tokyo - it’s all in reach.
                    </p>
                    <a
                      className="btn-sm text-white bg-purple-600 hover:bg-purple-700 mt-6"
                      href="https://elude.co/"
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </a>
                  </div>
                </article>
              </Transition>

              {/* space.game */}
              <Transition
                show={tab === 'space-game'}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-md mx-auto md:max-w-none">
                  <figure className="md:absolute md:inset-y-0 md:right-0 md:w-1/2">
                    <img
                      className="w-full h-full object-cover"
                      src={require("../images/space-game.gif")}
                      width="516"
                      height="387"
                      alt="space is a game"
                    />
                  </figure>
                  <div className="relative bg-gray-800 py-8 md:py-16 px-6 md:pr-16 md:max-w-lg lg:max-w-xl">
                    <h4 className="h4 mb-2">space.game</h4>
                      <p className="text-lg text-gray-400">
                        space.game is a casual arcade-style multiplayer game. It’s a light-hearted and vibrant world where friends and soon-to-be friends can meet and battle for space, collecting and trading NFT rewards along the way.
                      </p>
                    <a
                      className="btn-sm text-white bg-purple-600 hover:bg-purple-700 mt-6"
                      href="https://space.game"
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </a>
                  </div>
                </article>
              </Transition>
              
              {/* Betterment */}
              <Transition
                show={tab === 'betterment'}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-md mx-auto md:max-w-none">
                  <figure className="md:absolute md:inset-y-0 md:right-0 md:w-1/2">
                    <img
                      className="w-full h-full object-cover"
                      src={require("../images/betterment.jpeg")}
                      width="516"
                      height="387"
                      alt="Betterment app"
                    />
                  </figure>
                  <div className="relative bg-gray-800 py-8 md:py-16 px-6 md:pr-16 md:max-w-lg lg:max-w-xl">
                    <h4 className="h4 mb-2">Betterment</h4>
                      <p className="text-lg text-gray-400">
                        Betterment is the app that gives you the tools, inspiration, and advice to become a better investor.
                      </p>
                    <a
                      className="btn-sm text-white bg-purple-600 hover:bg-purple-700 mt-6"
                      href="https://betterment.com"
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </a>
                  </div>
                </article>
              </Transition>

              {/* Loft Orbital */}
              <Transition
                show={tab === 'loft-orbital'}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-md mx-auto md:max-w-none">
                  <figure className="md:absolute md:inset-y-0 md:right-0 md:w-1/2 p-4">
                    <img
                      className="w-1/3 mx-auto h-full object-contain"
                      src={require("../images/loft-orbital.png")}
                      alt="Loft Orbital"
                    />
                  </figure>
                  <div className="relative bg-gray-800 py-8 md:py-16 px-6 md:pr-16 md:max-w-lg lg:max-w-xl">
                    <h4 className="h4 mb-2">Loft Orbital</h4>
                      <p className="text-lg text-gray-400">
                         Loft Orbital builds software and hardware products to fly and operate any payload on a standard satellite bus. They make space simple.
                      </p>
                    <a
                      className="btn-sm text-white bg-purple-600 hover:bg-purple-700 mt-6"
                      href="https://www.loftorbital.com"
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </a>
                  </div>
                </article>
              </Transition>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Tabs;
